import { Component, ElementRef, OnInit, Renderer2, ViewChild, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { Table } from 'primeng/table';
import { LocalStorageService } from 'src/app/core/services/local-storage.service';
import { UserService } from 'src/app/core/services/user.service';
import { EstadoTelaPedidos, Pedido } from '../../pedido/models/pedido';
import { PedidoProduto } from '../../pedido/models/pedido-produto';
import { PedidoStatusFluxo } from '../../pedido/models/pedido-status-fluxo';
import { PedidoService } from '../../pedido/pedido.service';
import { EventoPedidoService } from '../eventoPedido.service';

@Component({
  selector: 'app-evento-pedido-list',
  templateUrl: './evento-pedido-list.component.html',
  styleUrls: ['./evento-pedido-list.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class EventoPedidoListComponent implements OnInit {

  public listaPedido: Pedido[];
  private idEvento: string;


  
  public displayMsg : boolean =false;
  public idPedido: string;  
  public listaStatusFluxo: PedidoStatusFluxo[] = [];
  public itemPedido: Pedido; 
  public msg: string = "Recebido"; 
  private idUsuario: number;
  public loginUsuario:string;
  public displayModal: boolean;
  public  first = 0;
  public rows = 10;
  public executouFiltro = false;
  public rowsPerPageOptions: number[] = [10, 20, 30,100];
  public statusCor = new Map<string, string>();

  public sincronizados:string[]=[];
  public sincronizados2:string[]=[];

  @ViewChild('filtro', { static: false }) filtro: ElementRef<HTMLInputElement>;;
  @ViewChild('dt', { static: false }) table: Table;
  @ViewChild('dt', {static: false}) private _table: Table;

  
  estado: EstadoTelaPedidos;
  estadoCopy: EstadoTelaPedidos;
  






     constructor(private _Activatedroute: ActivatedRoute,
      public pedidoService: PedidoService, 
      private router: Router, 
      private messageService: MessageService, 
      private confirmationService: ConfirmationService,
      private localStorage: LocalStorageService,
       private renderer: Renderer2,
       private userService: UserService) { 

        this.criarMap();
  
  
      this.estado = {} as EstadoTelaPedidos;
      this.estadoCopy  = (this.localStorage.hasItem('estadoPedido')?  JSON.parse(this.localStorage.getItem('estadoPedido')):{}) as EstadoTelaPedidos;
      this.sincronizados =(this.localStorage.hasItem('sincronizados')?  JSON.parse(this.localStorage.getItem('sincronizados')):[]) as string[];
          
      this.estado = {} as EstadoTelaPedidos;
      this.estado.pedidos = [];
      this.estado.totalElementos = 0;
      this.estado.first =0;
      this.estado.page =0;
      this.estado.rowsPerPage=this.rowsPerPageOptions[0];
  
  
      if(this.estadoCopy){
          this.estado.filtro = this.estadoCopy?.filtro;
          this.estado.first = this.estadoCopy?.first??0;
          this.estado.page = this.estadoCopy?.page??0;
          this.estado.rowsPerPage = this.estadoCopy?.rowsPerPage??10;
          this.estado.sort = this.estadoCopy.sort;
          this.estado.order = this.estadoCopy.order;
          
  
          if(this.estado.filtro && this.estado.filtro.length>0){
              this.executouFiltro=false;
          }else{
              this.first = this.estado.first;
              this.rows = this.estado.rowsPerPage;
              this.executouFiltro=true;
      }
      //console.log(this.executouFiltro);
          
      }
      
  
  
    }

  ngOnInit(): void {

    this.idUsuario = this.userService.getUserId(); 
        this.loginUsuario = this.userService.getUserName();
        console.log(this.idUsuario);
        console.log(this.loginUsuario);  
       
        this.getPedidoListaStatusFluxo('2', '1'); 
        


    this._Activatedroute.paramMap.subscribe(params => {
      if (params.has('idEvento')) {
        this.idEvento = params.get('idEvento');
          this.getPedidos()
      }
    });
  }


  
  
    


    ngAfterViewInit(): void {
        if(!this.executouFiltro){
        this._table.filterGlobal(this.estado.filtro,'contains');

        setTimeout( () => {   this.first = this.estado.first;
            this.rows = this.estado.rowsPerPage; }, 500 );
        
       this.filtro.nativeElement.value=this.estado.filtro;
       this.executouFiltro=true;
        }
       //this.filtro.nativeElement.dispatchEvent(new Event('keydown.enter', { bubbles: true }));
       //this._table._filter();

    }

    changeRowsPerPage(event): void {
       // console.log(event)
        this.estado.rowsPerPage = event.rows;
        this.estado.page =(event.first/event.rows)+1;
        this.estado.first =event.first;

        this.localStorage.setItem('estadoPedido',JSON.stringify(this.estado));
    }

    onFilter(event){
        //console.log(event)
        if(event.filters.global)
            this.estado.filtro =event.filters.global.value;
        else this.estado.filtro ='';
        //if(!this.executouFiltro)
         //   this.estado.first=0;
      
        
        this.localStorage.setItem('estadoPedido',JSON.stringify(this.estado));

  
    }

    openNew(){
      this.router.navigate(['/evento/'+this.idEvento+"/pedido"]);
    }

    onSort(event){
        console.log(event)
        this.estado.sort =event.field;
        this.estado.order =event.order;
        this.localStorage.setItem('estadoPedido',JSON.stringify(this.estado));
    }

    




    editPedido(idPedido)
    {
        this.router.navigate(['/evento/pedido', idPedido])                
    }

    printPedido(pedido: Pedido)
    {
        if(pedido.fornecedor=="COOPER" && pedido.idPagamentoRegra){
            this.router.navigate(['/pedido-pdf', pedido.idPedido]) 
        }else{
            this.router.navigate(['/evento-pedido-pdf', pedido.idPedido]) 
        }
                       
    }

    getPedidoListaStatusFluxo(idPedidoStatus: string, idUsuario: string){      

        this.pedidoService.getPedidoListaStatusFluxo(idPedidoStatus, idUsuario).subscribe(
               (res) => {
                   if (res) {                                       
                       this.listaStatusFluxo = res;                                                                                              
                      
                   }
               },
               err => {                
                   console.log("ERRO PEDIDO-STATUS-FLUXO: " + err);
               }
           ); 
    }


    AtualizarStatusLista(idPedido: string, idPedidoStatus: string)
    {        
        this.pedidoService.AtualizaPedidoStatus(idPedido, idPedidoStatus, this.idUsuario, null).subscribe(
        (res) => {
            if (res) {                  
              this.getPedidos();                                  
            }
        },
        err => {                
            console.log("ERRO PEDIDO-LIST ATUALIZA-STATUS: " + err);
        }
    );
    }
    

    
    getPedido(idPedido){      

        this.pedidoService.getPedidoEvento(idPedido).subscribe(
            (res) => {
                if (res) {        
                    this.itemPedido = res;                                          
                }
            },
            err => {                
                console.log("ERRO PEDIDO-DETALHE: " + err);
            }
        );
    }

    confirmStatus(idPedido: string, idPedidoStatusAtual: string, idPedidoStatus: string) {
        
console.log(idPedidoStatusAtual+' - '+idPedidoStatus);

        if (idPedidoStatus == "13"){
            if (idPedidoStatusAtual != "3"){
                this.msg = "Somente pedidos no status: RECEBIDO podem ser FINALIZADOS";
            }
            else {
                this.msg = "ENCERRADO";
            }
        }
        else{
            if (idPedidoStatusAtual != "2"){
                this.msg = "Somente pedidos no status TRANSMITIDO podem ser RECEBIDOS";
            }
            else {
                this.msg = "RECEBIDO";
            }
        }
        
        if (this.msg == "ENCERRADO" || this.msg == "RECEBIDO")
        {
            this.confirmationService.confirm({
                message: 'Você deseja atualizar o PEDIDO: '+idPedido+' para o status: '+this.msg+'?',
                header: 'Confirmation',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    
                    this.AtualizarStatusLista(idPedido, idPedidoStatus)
                },
                reject: () => {
                    
                }
            });
        }
        else
        {
            this.displayModal = true;
        }
    }

    next() {
        this.first = this.first + this.rows;
    }

    prev() {
        this.first = this.first - this.rows;
    }

    reset() {
        this.first = 0;
    }

    isLastPage(): boolean {
        return this.listaPedido ? this.first === (this.listaPedido.length - this.rows): true;
    }

    isFirstPage(): boolean {
        return this.listaPedido ? this.first === 0 : true;
    }


    criarMap(){
        this.statusCor.set('TRANSMITIDO','0');
        this.statusCor.set('RECEBIDO','1');
        this.statusCor.set('FINALIZADO','2');
        this.statusCor.set('EMITIDO','3');
    }

    verificarSync(){
        let synced:string[]=[];
        let notSynced:string[]=[];
        this.listaPedido.forEach(element => {
            if(this.sincronizados.includes(element.idPedido)){
                element.synced=true;
                this.sincronizados2.push(element.idPedido);
            }else{
                this.getPedidoListaProduto(element)
            }
        });

      
    }

    getPedidoListaProduto(ped: Pedido){              

        this.pedidoService.getPedidoProdutoLista(ped.idPedido).subscribe(
               (res) => {
                   if (res) {     
                      let prods: PedidoProduto[];
                      prods = res;  
                        let soma:number=0;
                        prods.forEach(element => {
                            soma+=element.vlTotal;
                        });
                        if(Math.round(soma)!=Math.round(ped.vlPedido)){
                            ped.synced=false;
                            console.log(ped.idPedido+"-"+soma+' '+ped.vlPedido)
                        }else{
                            ped.synced=true;
                            this.sincronizados2.push(ped.idPedido);
                        }

                        this.localStorage.setItem('sincronizados',JSON.stringify(this.sincronizados2));
                        
                   }
               },
               err => {                
                   console.log("ERRO PEDIDO-PRODUTO: " + err);
               }
           ); 
    }


  getPedidos(){      

    this.pedidoService.getPedidosEvento(this.idEvento).subscribe(
        (res) => {
            if (res) {        
                this.listaPedido = res;                                          
            }
        },
        err => {                
            console.log("ERRO PEDIDO-DETALHE: " + err);
        }
    );
}



}
